import script from "./MenuBarArea.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBarArea.vue?vue&type=script&setup=true&lang=js"

import "./MenuBarArea.vue?vue&type=style&index=0&id=41bf673e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41bf673e"]])

export default __exports__